import { E } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollProcessService } from 'app/core/services/payroll-process.service';
import { PrivateService } from 'app/core/services/private.service';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';
import { ToastrService } from 'ngx-toastr';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'dialog-process-timesheet',
  templateUrl: './dialog-process-timesheet.component.html',
  styleUrls: ['./dialog-process-timesheet.component.scss']
})
export class DialogProcessTimesheetComponent implements OnInit {

  payrolls: any[] = [];
  period: any[] = [];
  processForm: FormGroup;
  processForm2: FormGroup;
  schedules: any[] = [];

  payrollCtrl = new FormControl('');
  periodCtrl = new FormControl('');
  scheduleCtrl = new FormControl('');

  filteredPayrolls!: Observable<any[]>;
  filteredPeriods!: Observable<any[]>;
  filteredSchedules!: Observable<any[]>;

  isLoading: boolean = false;
  isProcessed: boolean = false;
  message: string = '';
  statusList: any[] = [];
  status: string = '';

  constructor(public dialogRef: MatDialogRef<DialogProcessTimesheetComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private fb: FormBuilder, private processSchedulerService: ProcessSchedulerService,
    private toastr: ToastrService, private payrollProcessService: PayrollProcessService) {
    this.processForm = this.fb.group({
      payroll: ['', Validators.required],
      period: ['', Validators.required],
      schedule: ['', Validators.required],
      status: [''],
      // startDate: ['', Validators.required],
    });
    this.processForm2 = this.fb.group({
      payroll: [0, Validators.required],
      period: ['', Validators.required],
      status: [''],
      // startDate: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getPayrolls();
    this.getSchedules();
    this.periodCtrl.disable();

    this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.payrolls, 'payrollType'))
    );

    this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.period, 'payrollName'))
    );

    this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.schedules, 'name'))
    );

    if (this.data.Payroll_Type_ID > 0) {
      this.privateService.getPayrollType().subscribe(res => {
        this.payrolls = res;
        this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.payrolls, 'payrollType'))
        );
        this.privateService.getPeriodOnDepartment(this.data.Payroll_Type_ID).subscribe(response => {
          this.period = response;
          this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value, this.period, 'payrollName'))
          );
          const selected: any = this.payrolls.find(d => d.hrpayrollID === +this.data.Payroll_Type_ID);
          const selectedPeriod: any = this.period.find(d => d.hrperiodID === String(this.data.HR_Period_ID));
          this.processForm2.patchValue({
            payroll: +this.data.Payroll_Type_ID,
            period: String(this.data.HR_Period_ID)
          });
          if (selected) {
            this.payrollCtrl.setValue(selected.payrollType);
          }
          if (selectedPeriod) {
            this.periodCtrl.setValue(selectedPeriod.payrollName);
          }
        })
      });
    }

    this.payrollCtrl.valueChanges.subscribe(value => {
      if (!value) {
        this.periodCtrl.disable();
        this.periodCtrl.setValue('');
      } else {
        this.periodCtrl.enable();
      }
    });
    if (this.data.docStatus === 'Drafted') {
      this.status = 'DR';
    }
    if (this.data.docStatus === 'In Progress') {
      this.status = 'IP';
    }
    if (this.data.docStatus === 'Completed') {
      this.status = 'CO';
    }
    this.getDocStatuses();
  }

  getDocStatuses() {
    this.payrollProcessService.getCommonDocStatuses().subscribe({
      next: res => {
        this.statusList = res;
        if (this.data.docStatus !== 'Complete') {
          this.statusList = res.filter((status: any) => status.value !== 'RE');
        }
        if (this.data.docStatus === 'Complete') {
          this.statusList = res.filter((status: any) => status.value === 'RE');
        }
      }
    })
  }

  private _filter(value: string, list: any[], key: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return list?.filter(item => item[key]?.toLowerCase().includes(filterValue));
  }

  onNoClick(): void {
    this.dialogRef.close(this.isProcessed);
  }

  getSchedules() {
    this.processSchedulerService.getSchedules().subscribe({
      next: res => {
        this.schedules = res;
        this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.schedules, 'name'))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getPayrolls() {
    this.privateService.getPayrollType().subscribe(res => {
      this.payrolls = res;
      this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.payrolls, 'payrollType'))
      );
    });
  }

  onPayrollSelected(payrollType: string) {
    const selected: any = this.payrolls.find(d => d.payrollType === payrollType);
    if (selected) {
      this.processForm.get('payroll')?.setValue(selected.hrpayrollID);
    }
    this.privateService.getPeriodOnDepartment(selected.hrpayrollID).subscribe(response => {
      console.log(response);
      this.period = response;
      this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.period, 'payrollName'))
      );
    })
  }

  onPeriodSelected(payrollName: string) {
    const selected = this.period.find(e => e.payrollName === payrollName);
    if (selected) {
      this.processForm.get('period')?.setValue(selected.hrperiodID);
    }
  }

  onScheduleSelected(name: string) {
    const selected = this.schedules.find(c => c.name === name);
    if (selected) {
      this.processForm.get('schedule')?.setValue(selected.id);
    }
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.data.type === 'timesheet') {
      if (this.processForm2.invalid) {
        ;
        this.showNotificationError("Form is Invalid.");
        this.isLoading = false;
        return;
      }
      const formData = {
        ...this.processForm2.value,
        timesheetID: this.data.id,
        employeeID: this.data.C_BPartner_ID,
        status: this.status
      };
      console.log(formData);
      this.processSchedulerService.insert_timesheet_process_immediate(formData).subscribe((res) => {
        this.isLoading = false;
        this.isProcessed = true;
        this.message = res.message;
      });
    } else {
      if (this.processForm.invalid) {
        this.showNotificationError("Form is Invalid.");
        this.isLoading = false;
        return;
      }
      const formData = this.processForm.value;
      this.processSchedulerService.insert_timesheet_process(formData).subscribe((res) => {
        this.isLoading = false;
        this.dialogRef.close();
      })
    }
  }

  showNotificationError(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }
}
